import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { checkNotAdmin } from "utils/utils";

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider
    store={
      checkNotAdmin()
        ? require("./store/store").default
        : require("./store/adminStore").default
    }
  >
    <App />
  </Provider>
);
